import React from 'react';
import { Calendar, Milestone, Check, Clock, AlertCircle } from 'lucide-react';

const ROADMAP_DATA = {
  title: "Roadmap Produit 2024-2025",
  description: "Planning des futures fonctionnalités",
  milestones: [
    {
      quarter: "Q2 2024",
      title: "Version 2.0",
      status: "in_progress",
      features: [
        "Nouvelle interface utilisateur",
        "Authentification SSO",
        "Mode sombre"
      ]
    },
    {
      quarter: "Q3 2024",
      title: "Version 2.1",
      status: "planned",
      features: [
        "Export des données en PDF",
        "Tableaux de bord personnalisables",
        "API publique"
      ]
    },
    {
      quarter: "Q4 2024",
      title: "Version 2.2",
      status: "planned",
      features: [
        "Intégration IA",
        "Chat temps réel",
        "Notifications avancées"
      ]
    },
    {
      quarter: "Q1 2025",
      title: "Version 3.0",
      status: "planned",
      features: [
        "Applications mobiles",
        "Mode hors ligne",
        "Synchronisation multi-appareils"
      ]
    }
  ]
};

const StatusIcon = ({ status }) => {
  switch (status) {
    case 'completed':
      return <Check className="h-5 w-5 text-green-500" />;
    case 'in_progress':
      return <Clock className="h-5 w-5 text-blue-500" />;
    case 'delayed':
      return <AlertCircle className="h-5 w-5 text-red-500" />;
    default:
      return <Milestone className="h-5 w-5 text-gray-400" />;
  }
};

const TimelineMilestone = ({ milestone, isLast }) => (
  <div className="relative pb-12">
    {!isLast && (
      <div
        className="absolute left-6 top-8 bottom-0 w-0.5 bg-gray-200"
        aria-hidden="true"
      />
    )}
    
    <div className="relative flex items-start">
      <div className="flex-shrink-0 h-12 w-12 flex items-center justify-center bg-white rounded-full border-2 border-gray-200">
        <StatusIcon status={milestone.status} />
      </div>
      
      <div className="ml-6">
        <div className="flex items-center space-x-2">
          <Calendar className="h-4 w-4 text-gray-400" />
          <span className="text-sm font-medium text-gray-500">{milestone.quarter}</span>
          <span 
            className={`px-2 py-1 text-xs font-medium rounded-full ${
              milestone.status === 'completed' ? 'bg-green-100 text-green-800' :
              milestone.status === 'in_progress' ? 'bg-blue-100 text-blue-800' :
              milestone.status === 'delayed' ? 'bg-red-100 text-red-800' :
              'bg-gray-100 text-gray-800'
            }`}
          >
            {milestone.title}
          </span>
        </div>
        
        <ul className="mt-3 space-y-2">
          {milestone.features.map((feature, index) => (
            <li 
              key={index}
              className="flex items-center space-x-2 text-gray-600"
            >
              <span className="w-1.5 h-1.5 bg-blue-500 rounded-full" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

const SimpleRoadmap = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold text-gray-900">
          {ROADMAP_DATA.title}
        </h1>
        <p className="mt-2 text-gray-600">
          {ROADMAP_DATA.description}
        </p>
      </div>

      {/* Legend */}
      <div className="flex justify-center gap-6 mb-12">
        <div className="flex items-center gap-2">
          <Check className="h-4 w-4 text-green-500" />
          <span className="text-sm text-gray-600">Terminé</span>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4 text-blue-500" />
          <span className="text-sm text-gray-600">En cours</span>
        </div>
        <div className="flex items-center gap-2">
          <Milestone className="h-4 w-4 text-gray-400" />
          <span className="text-sm text-gray-600">Planifié</span>
        </div>
        <div className="flex items-center gap-2">
          <AlertCircle className="h-4 w-4 text-red-500" />
          <span className="text-sm text-gray-600">Retardé</span>
        </div>
      </div>

      {/* Timeline */}
      <div className="relative">
        {ROADMAP_DATA.milestones.map((milestone, index) => (
          <TimelineMilestone
            key={milestone.quarter}
            milestone={milestone}
            isLast={index === ROADMAP_DATA.milestones.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export default SimpleRoadmap;